<app-generic-button
  [disabled]="disabled"
  [color]="color"
  [clickEvent]="clickEvent"
  [textContent]="textContent"
>
</app-generic-button>
